export default __webpack_public_path__ + "static/media/whatsapp.03ed68e4.svg";